// src/components/Screen7_Quiz.jsx
import React, { useState } from 'react';
import { useAppContext } from '../context/AppContext';
import { submitAllData } from '../api';

function Screen7_Quiz() {
    const { 
        userInfo, 
        rankingsTestDrive, // <-- NEW
        rankingsDesign,    // <-- NEW
        rankingsInterior,  // <-- NEW
        quizAnswers, 
        setQuizAnswers, 
        quizConsent, 
        setQuizConsent, 
        showScreen 
    } = useAppContext();
    
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');

    const handleChange = (e) => {
        const { name, value } = e.target;
        setQuizAnswers(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleConsentChange = (e) => {
        setQuizConsent(e.target.checked);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (isSubmitting) return;

        setIsSubmitting(true);
        setError('');
        
        // UPDATED payload
        const finalPayload = {
            userInfo,
            rankings: {
                test_drive: rankingsTestDrive,
                design: rankingsDesign,
                interior: rankingsInterior
            },
            quiz: quizAnswers,
            consent: quizConsent
        };
                                   
        try {
            const result = await submitAllData(finalPayload);
            if (result.success) {
                showScreen('screen-8-thankyou'); // <-- UPDATED navigation
            } else {
                                              
                setError(result.message || 'Submission failed. Please try again.');
                setIsSubmitting(false);
            }
        } catch (err) {
            setError('An error occurred. Please try again.');
            setIsSubmitting(false);
        }
    };

    // ... (Validation logic remains the same) ...
    const allFilled = quizAnswers.q1.trim() && quizAnswers.q2a.trim() && quizAnswers.q2b.trim();
    const isAllValid = allFilled && quizConsent;

    let infoText = 'Please answer all questions and provide consent to submit.';
    if (allFilled && !quizConsent) {
        infoText = 'Please agree to the consent for data sharing.';
    } else if (!allFilled) {
        infoText = 'Please answer all questions to submit.';
    }

    return (
        <div id="screen-7-quiz" className="screen screen_padding">
            <h2 className="title_style text-2xl font-semibold text-center mb-6">Final Questions</h2>
            
            <form id="quiz-form" className="space-y-4" onSubmit={handleSubmit}>
                {/* ... (Quiz inputs and consent checkbox remain the same) ... */}
                <div>
                    <label htmlFor="quiz-q1" className="block text-sm font-medium medium_text_style">How old is COTY?</label>
                    <input type="text" id="quiz-q1" name="q1" value={quizAnswers.q1} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                </div>
                
                <div>
                    <label htmlFor="quiz-q2a" className="block text-sm font-medium medium_text_style">Who are the partners in the roadshow? Please name 2.</label>
                    <input type="text" id="quiz-q2a" name="q2a" placeholder="Partners 1" value={quizAnswers.q2a} onChange={handleChange} className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                    <input type="text" id="quiz-q2b" name="q2b" placeholder="Partners 2" value={quizAnswers.q2b} onChange={handleChange} className="mt-2 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" />
                </div>

                <div className="flex items-start">
                    <input 
                        id="consent-pdpa" 
                        name="consent-pdpa" 
                        type="checkbox" 
                        className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                        checked={quizConsent}
                        onChange={handleConsentChange}
                    />
                    <div className="ml-2 text-sm">
                        <label htmlFor="consent-pdpa" className="font-medium">Consent for Data Sharing</label>
                        <p className="text-gray-500 text-xs">I hereby consent to the collection, use, and sharing of my personal data by the organisers for purposes related to this event. I understand that my information may be shared with MARii, Car of the Year (COTY), event organisers, and official partners for communication, marketing, and reporting purposes, in accordance with the Personal Data Protection Act 2010 (PDPA).</p>
                    </div>
                </div>

                                                                  
                {error && <p id="quiz-info" className="text-center text-sm text-red-500 mt-2">{error}</p>}

                <button 
                    type="submit" 
                    id="submit-quiz-btn" 
                    disabled={!isAllValid || isSubmitting}
                    className="w-full flex justify-center py-3 px-4 border border-transparent rounded-md shadow-sm text-lg font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50"
                >
                    {isSubmitting ? (
                        <>
                            <i className="fas fa-spinner fa-spin mr-2"></i> Submitting...
                        </>
                    ) : (
                        'Submit' // <-- UPDATED Button Text
                    )}
                </button>
                                                                         
                {!isAllValid && !error && <p id="quiz-info" className="text-center text-sm text-gray-500 mt-2">{infoText}</p>} 
            </form>
        </div>
    );
}

export default Screen7_Quiz;